import {useEffect} from 'react';
import {useHistory} from 'helpers';

export function useRedirectToFirstCard(fallback: string | null, on = true) {
  const {replace, location} = useHistory();
  useEffect(() => {
    const [card] = document.querySelectorAll('aside a[data-id]');
    const url = card?.getAttribute('href');
    if (location.pathname !== url) {
      if (url && on) {
        replace(url);
      } else if (fallback) {
        replace(fallback);
      }
    }
  }, [location.pathname]);
  return null;
}
